import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=7013b35e"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=7013b35e&prod&lang=scss"
import style1 from "./DeleteModal.vue?vue&type=style&index=1&id=7013b35e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports